import React, {useState} from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SvgLogo from '@syte-tech/ui/icons/Logo';
import FeedBackPopup from './FeedBackPopup';

const MapSidebarHeader: React.FC<{props: BoxProps, buildingId: string}> = ({props, buildingId}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  
      const handleOpenPopup = () => {
          setIsPopupVisible(true);
      };
  
      const handleClosePopup = () => {
          setIsPopupVisible(false);
      };

  return <Box padding={3} bgcolor="background.paper" {...props}>
    <Stack direction="row" alignItems="center" gap={4}>
      <Link href="https://syte.ms" target="_blank">
        <SvgLogo fontSize={40} />
      </Link>
      <Link
        href="https://enersyte.de"
        target="_blank"
        variant='body1'
        position="relative"
        bottom={5}
        fontSize={16}
        underline='none'
      >
        ENERsyte
      </Link>
      <div className="feedback-menu">
        <Button
          color="secondary"
          onClick={handleOpenPopup}
        >
          Feedback geben
        </Button>
      </div>
      <FeedBackPopup isVisible={isPopupVisible} onClose={handleClosePopup} buildingId={buildingId}/>
    </Stack>
    <Typography variant="h1" fontSize={34} paddingTop={6} paddingBottom={2}>
      PV Pro
    </Typography>
    <Typography variant="h4" component="h2" color="text.secondary">
      Das PV-Planungswerkzeug
    </Typography>
  </Box>
;}

export default MapSidebarHeader;